// extracted by mini-css-extract-plugin
export default {"container":"KK-z","topReviewHeading":"LK-z","criticalReview":"MK-z","favorableReview":"NK-z","vsSeparator":"OK-z"};